import type {LanguageSelectorTranslation} from '../languageSelectorTranslationType';

export const translation: LanguageSelectorTranslation = {
  nav: {
    homeAriaLabel: (ctx) => `خانهٔ ${ctx.brand}`,
    languageButtonLabel: `زبان`,
    languageModalTitle: `یک زبان انتخاب کن`,
    languageModalCloseLabel: `بستن فهرست زبان‌ها`,
  },
  languageOptions: {
    'en-US': {
      label: `انگلیسی`,
      countryCodes: [`US`],
    },
    'en-KE': {
      label: `انگلیسی (کنیا)`,
      countryCodes: [`KE`],
    },
    'en-NG': {
      label: `انگلیسی (نیجریه)`,
      countryCodes: [`NG`],
    },
    'en-SG': {
      label: `انگلیسی (سنگاپور)`,
      countryCodes: [`SG`],
    },
    'pt-PT': {
      label: `پرتغالی`,
      countryCodes: [`PT`],
    },
    'pt-BR': {
      label: `Português (Brasil)`,
      countryCodes: [`BR`],
    },
    'de-DE': {
      label: `آلمانی`,
      countryCodes: [`DE`],
    },
    'de-AT': {
      label: `Deutsch (Österreich)`,
      countryCodes: [`AT`],
    },
    'de-CH': {
      label: `Deutsch (Schweiz)`,
      countryCodes: [`CH`],
    },
    'es-ES': {
      label: `اسپانیایی`,
      countryCodes: [`ES`],
    },
    'fr-FR': {
      label: `فرانسوی`,
      countryCodes: [`FR`],
    },
    'it-IT': {
      label: `ایتالیایی`,
      countryCodes: [`IT`],
    },
    'nl-NL': {
      label: `هلندی`,
      countryCodes: [`NL`],
    },
    'pl-PL': {
      label: `Polski`,
      countryCodes: [`PL`],
    },
    'sv-SE': {
      label: `نوردیک و بالتیک`,
      countryCodes: [`SE`],
    },
    'da-DK': {
      label: `Dansk`,
      countryCodes: [`DK`],
    },
    'fi-FI': {
      label: `Suomi`,
      countryCodes: [`FI`],
    },
    'no-NO': {
      label: `Norsk`,
      countryCodes: [`NO`],
    },
    'is-IS': {
      label: `Íslenska`,
      countryCodes: [`IS`],
    },
    'ja-JP': {
      label: `ژاپنی`,
      countryCodes: [`JP`],
    },
    'ko-KR': {
      label: `کره‌ای`,
      countryCodes: [`KR`],
    },
    'zh-Hans-CN': {
      label: `چینی ماندارین`,
      countryCodes: [`CN`],
    },
    'yue-Hant-HK': {
      label: `چینی کانتونی`,
      countryCodes: [`HK`],
    },
    'vi-VN': {
      label: `Tiếng Việt`,
      countryCodes: [`VN`],
    },
    'th-TH': {
      label: `تایلندی`,
      countryCodes: [`TH`],
    },
    'id-ID': {
      label: `Bahasa Indonesia`,
      countryCodes: [`ID`],
    },
    'sw-KE': {
      label: `Kiswahili`,
      countryCodes: [`KE`],
    },
    'hi-IN': {
      label: `هندی`,
      countryCodes: [`IN`],
    },
    'bn-BD': {
      label: `বাংলা`,
      countryCodes: [`BD`],
    },
    'mr-IN': {
      label: `मराठी`,
      countryCodes: [`IN`],
    },
    'te-IN': {
      label: `తెలుగు`,
      countryCodes: [`IN`],
    },
    'fa-IR': {
      label: `فارسی`,
      countryCodes: [`IR`],
    },
    'ur-PK': {
      label: `اردو`,
      countryCodes: [`PK`],
    },
    'pa-PK': {
      label: `پنجابی`,
      countryCodes: [`PK`],
    },
    'pcm-NG': {
      label: `Naijá Pidgin`,
      countryCodes: [`NG`],
    },
    'ru-RU': {
      label: `روسی`,
      countryCodes: [`RU`],
    },
    'ar-SA': {
      label: `عربی`,
      countryCodes: [`SA`],
    },
    'ar-AE': {
      label: `العربية (الإمارات)`,
      countryCodes: [`AE`],
    },
    'ar-QA': {
      label: `العربية (قطر)`,
      countryCodes: [`QA`],
    },
    'ar-MA': {
      label: `دارجه مراکشی`,
      countryCodes: [`MA`],
    },
    'tr-TR': {
      label: `Türkçe`,
      countryCodes: [`TR`],
    },
  },
  languageModal: {
    title: `یک زبان انتخاب کن`,
    closeLabel: `بستن فهرست زبان‌ها`,
  },
  languageHint: (ctx) => `بین بیش از ${ctx.localesCount}+ زبان جابه‌جا شو.`,
  readPagePrompt: ({languageLabel}) => `این صفحه را به زبان ${languageLabel} بخوانید.`,
};
